"use client";

import { Button, ButtonProps, Icon, useToast } from "@stone-payments/jade";
import { Skeleton } from "@/components/skeleton";

type Props = {
  url: string;
  text: string;
  onShare?: () => void;
  loading?: boolean;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
  className?: string;
};

export const CopyShareButton = ({
  url,
  text,
  onShare,
  size = "medium",
  variant = "neutral-ghost",
  loading = true,
  className,
}: Props) => {
  const { addToast } = useToast();

  if (loading) return <Skeleton height="h-12" width="w-full" />;

  const copyLink = () => {
    try {
      navigator.share({
        url: url,
        text: text,
      });
    } catch {
      navigator.clipboard.writeText(url);
      addToast({
        leading: <Icon color="on-color-high" size="large" use="check" />,
        text: `O link deste produto foi copiado. Mostre ele pra alguém!`,
      });
    }

    onShare?.();
  };

  return (
    <Button
      icon="action-share"
      onClick={copyLink}
      size={size}
      variant={variant}
      className={`text-nowrap ${className}`}
      data-testid="product-share-button"
    >
      Compartilhe com alguém
    </Button>
  );
};
